import styled from "styled-components";

const AgreementNotes = styled.div`
  width: 100%;
  height:auto;
  padding: 1.5rem;
  border: 1px solid #a9abb3;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export default AgreementNotes;
